/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Trust_Experience_TitleInputs */

const en_home_trust_experience_title = /** @type {(inputs: Home_Trust_Experience_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`35 Years Experience`)
};

const fr_home_trust_experience_title = /** @type {(inputs: Home_Trust_Experience_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`35 ans d'expérience`)
};

/**
* | output |
* | --- |
* | "35 Years Experience" |
*
* @param {Home_Trust_Experience_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_trust_experience_title = /** @type {((inputs?: Home_Trust_Experience_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trust_Experience_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_trust_experience_title(inputs)
	return fr_home_trust_experience_title(inputs)
});